import React, { FC } from "react";
import { Button, ButtonProps } from "@mui/material";

type VcButtonSize = "lg" | "md" | "sm" | "xs";

export interface VcButtonProps extends ButtonProps {
  text?: string;
  btnSize?: VcButtonSize;
  icon?: any;
  iconStart?: any;
  iconEnd?: any;
}

const VcButton: FC<VcButtonProps> = ({
  text,
  icon: Icon,
  iconStart: StartIcon,
  iconEnd: EndIcon,
  btnSize = "md",
  variant = "contained",
  color = "primary",
  ...buttonProps
}) => {
  const props: any = getPropsFromSize(btnSize, Boolean(Icon));

  return (
    <Button
      variant={variant}
      size={props.size}
      style={props?.style}
      color={color}
      {...buttonProps}
    >
      {StartIcon ? (
        <StartIcon style={{ ...props.iconStyle, marginRight: "10px" }} />
      ) : null}
      {Icon ? <Icon style={props.iconStyle} /> : text}
      {EndIcon ? (
        <EndIcon style={{ ...props.iconStyle, marginLeft: "10px" }} />
      ) : null}
    </Button>
  );
};

export default VcButton;

const getPropsFromSize = (size: VcButtonSize, withIcon?: boolean) => {
  switch (size) {
    case "lg":
      return {
        size: "large",
        iconStyle: { width: 24, height: 24 },
        style: withIcon ? { padding: "16px 20px" } : {},
      };
    case "md":
      return {
        size: "medium",
        iconStyle: { width: 24, height: 24 },
        style: withIcon ? { padding: "12px 16px" } : {},
      };
    case "sm":
      return {
        size: "small",
        iconStyle: { width: 20, height: 20 },
        style: withIcon ? { padding: "10px 12px" } : {},
      };
    case "xs":
      return {
        size: "small",
        iconStyle: { width: 16, height: 16 },
        style: {
          minHeight: 32,
          minWidth: 90,
          padding: withIcon ? "8px 12px" : "5px 12px",
          lineHeight: "22px",
          fontSize: 13,
        },
      };
    default:
      return {
        size: "medium",
      };
  }
};
